import { RootState } from '../../store';
import * as Pr from '../../data/product';
import { createSelector } from '@reduxjs/toolkit';
import * as Core from './core';

const requireSku = (_state: RootState, sku: string) => sku;
const productData = (state: RootState) => state.productData;

/**
 * Raw bundle data (only for bundle products)
 */
export const bundles = createSelector(productData, productData => productData.bundles);

export const discontinuedBundles = createSelector(bundles, bs => bs?.filter(b => b.discontinued));

/** Bundles which are not Discontinued */
export const activeBundles = createSelector(bundles, bs => bs?.filter(b => !b.discontinued));

/**
 * Raw product data (includes normal and bundle products)
 */
export const products = createSelector(productData, productData => productData.products);

export const discontinuedProducts = createSelector(products, ps => ps?.filter(p => p.discontinued));

/** Products which are not discontinued */
export const activeProducts = createSelector(products, ps => ps?.filter(p => !p.discontinued));

/**
 * Select a product using a SKU at selection time
 */
export const productBySku = createSelector(products, requireSku, (products, sku) =>
    products === null ? null : products.find(pd => Pr.productId(pd) === sku),
);

/**
 * Select a function which takes a SKU and returns a Product with that SKU if it exists
 */
export const productBySkuFn = createSelector(products, ps =>
    ps ? (sku: string) => ps.find(p => Pr.productId(p) === sku) : null,
);

export const productsByGroupingCode = createSelector(
    products,
    products => (groupingCode: string) => products?.filter(p => p.groupingCode === groupingCode),
);

export const bundlesForRange = createSelector(activeBundles, Core.range, (bundles, range) => {
    return range ? bundles?.filter(b => b.ranges.includes(range)) : null;
});
